/** Shared Loro container id for the attachments index, kept in sync with the client. */
export const ATTACHMENTS_CONTAINER_ID = 'attachments';
/**
 * Collaborative view of the room's uploaded files. Mirrors {@link Suggestions}:
 * a Loro list of {@link FileMeta} that broadcasts on every commit, so every peer
 * sees the same attachments and late joiners hydrate from the snapshot.
 *
 * The authoritative bytes + version history live in {@link FileStore} (R2 +
 * SQLite); this list is the synced index, kept in step by the agent wiring the
 * `after:document:upload` event to {@link record}.
 */
export class Attachments {
    loroDoc;
    listId;
    /** @param options - Shared-document and container options for the attachment index. */
    constructor(options) {
        this.loroDoc = options.doc;
        this.listId = options.listContainer ?? ATTACHMENTS_CONTAINER_ID;
    }
    /**
     * Upserts metadata by path so the latest version replaces the prior row.
     *
     * @param meta - Latest uploaded-file metadata to upsert.
     */
    record(meta) {
        const list = this.rawList();
        const items = list.toArray();
        const index = items.findIndex((m) => m.path === meta.path);
        if (index === -1)
            list.push(meta);
        else
            list.set(index, meta);
        this.loroDoc.commit();
    }
    /**
     * Removes an attachment from the synchronized index.
     *
     * @param path - Attachment path to remove.
     */
    remove(path) {
        const list = this.rawList();
        const items = list.toArray();
        const index = items.findIndex((m) => m.path === path);
        if (index === -1)
            return;
        list.delete(index, 1);
        this.loroDoc.commit();
    }
    /**
     * Lists attachments.
     *
     * @returns Attachment metadata in insertion order.
     */
    list() {
        return this.rawList().toArray();
    }
    rawList() {
        return this.loroDoc.getMovableList(this.listId);
    }
}
//# sourceMappingURL=attachments.js.map